import { always, both, isEmpty, pipe, reject, when } from 'rambda'

export const cleanQuery = pipe(
  reject(both(
    Array.isArray,
    isEmpty,
  )),
  when(isEmpty, always(null)),
)
